<template>
  <div class="page">
    <div class="content">
      <slot></slot>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer  from '@/components/footer.vue'

export default {
  name: 'page',
  components:{Footer},
  props:{}
}
</script>

<style scoped>
.content{min-height: calc(100vh - 17vw);}

@media (max-width:991px){
.content{min-height: calc(100vh - 32vw - 55px);}

}
</style>